import { createFileRoute } from '@tanstack/react-router'

import {
  TablesPageDesktop,
  TablesPageMobile,
} from '@/components/pages/Dashboard/Tables/TablesPage'
import { useIsMobile } from '@/hooks/useIsMobile'

export const Route = createFileRoute('/_liff/admin/tables')({
  component: TablesPage,
})

function TablesPage() {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <TablesPageMobile />
  }

  return <TablesPageDesktop />
}
